<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import TopAlerts from '@components/topalerts'
// import Alerts from './alerts'

import axios from 'axios'

export default {
	page: {
		title: 'Gropued Alerts',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, TopAlerts },
	data() {
		return {
			title: 'Grouped Alerts',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Grouped Alerts',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<TopAlerts :source="'/pan/xdr/alerts/info/top?limit=1000000'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>